import { produce } from "immer";
import {
  FETCH_PACKAGES,
  FETCH_PACKAGES_SUCCESS,
  FETCH_PACKAGES_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_PACKAGE,
  ADD_PACKAGE_SUCCESS,
  ADD_PACKAGE_FAILURE,
  //
  EDIT_PACKAGE,
  EDIT_PACKAGE_SUCCESS,
  EDIT_PACKAGE_FAILURE,
  //
  DELETE_PACKAGE,
  DELETE_PACKAGE_SUCCESS,
  DELETE_PACKAGE_FAILURE,
} from "./constants";

export const initialState = {
  isFetching: false,
  packages: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentPackage: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
};

const PackageReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_PACKAGES:
        draft.isFetching = true;
        draft.packages = [];
        break;
      case FETCH_PACKAGES_SUCCESS:
        draft.isFetching = false;
        draft.packages = action.payload;
        break;
      case FETCH_PACKAGES_FAILURE:
        draft.isFetching = false;
        draft.packages = [];
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentPackage = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentPackage = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        draft.currentPackage = {};
        break;
      // Add
      case ADD_PACKAGE:
        draft.isSubmitting = true;
        break;
      case ADD_PACKAGE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_PACKAGE_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_PACKAGE:
        draft.isSubmitting = true;
        break;
      case EDIT_PACKAGE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_PACKAGE_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_PACKAGE:
        draft.isDeleting = true;
        break;
      case DELETE_PACKAGE_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_PACKAGE_FAILURE:
        draft.isDeleting = false;
        break;
      default:
        return state;
    }
  });

export default PackageReducer;
